import { ThunkAPI } from '../rootReducer';
import { HttpMethods, SERVICES } from '../../services/api';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { push } from 'connected-react-router';

export interface IRemoveSeats {
  customerId: string;
  seatsToRemoveQty: number;
  usersToRemove: string[];
}

export const fetchCustomerSubscription: AsyncThunk<void, string, ThunkAPI> = createAsyncThunk(
  'FetchCustomerSubscription',
  async (customerId: string, thunk) => {
    try {
      return basicApiAsyncThunkCreator<void, void>({
        endpoint: `customer/${customerId}/subscription`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
    } catch (err) {
      thunk.dispatch(showErrorMessage(err as string || 'An error occurred fetching the subscription data.'));
      return thunk.rejectWithValue(err);
    }
  }
);

export const startCancellationProcessForPlgExternal2: AsyncThunk<void, string, ThunkAPI> = createAsyncThunk(
  'accountSubscription',
  async (accountId: string, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, void>({
        endpoint: 'customer/subscription/startCancellation',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(undefined, thunk);
      thunk.dispatch(showSuccessMessage('Subscription cancelled successfully'));
      thunk.dispatch(push('/settings/subscription'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage(err as string || 'An error occurred cancelling the subscription'));
      return thunk.rejectWithValue(err);
    }
  }
);

export const removeSeatsForPlgExternal2 = createAsyncThunk(
  'accountSubscription/removeSeats',
  async (data: IRemoveSeats, thunk) => {
    try {
      const { customerId, ...endpointData } = data;
      await basicApiAsyncThunkCreator({
        endpoint: `customer/${data.customerId}/subscription/removeSeats`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(endpointData, thunk);
      thunk.dispatch(showSuccessMessage('Your subscription has been updated successfully'));
      thunk.dispatch(push({
        pathname: '/settings/subscription',
        state: { refreshAccountData: true }
      }));
    } catch (err) {
      thunk.dispatch(showErrorMessage('An error occurred while updating your subscription'));
      return thunk.rejectWithValue(err);
    }
  }
);
